export const listBlueprintShares = [
  {
    AppCount: 2,
    BlueprintId: "dc3bbf77bf67-ace2-8a0e-5a7c-ffd4831fUib12",
    LastStatus: null,
    LastUsed: null,
    OrganizationId: "85f5ed19-db77-4aeb-95ba-37cc08282f8f",
    ShareStatus: "SHARE_SUCCESS",
  },
];
